// extracted by mini-css-extract-plugin
module.exports = {"container":"GoogleLoginWrapper_container__1Rdt4","googleLogo":"GoogleLoginWrapper_googleLogo__2uHbi"};